import React, { useState, useEffect, ElementType, ReactElement } from 'react';
import styled from 'styled-components';

import { CalculatorSelectionTotalPageProps } from '../../models';
import { devicesTotalValue, formatDollars } from '../../utils';
import getPartnerAsset, { DynamicAssetsKeys } from 'packages/smart-home-support/assets';
import BREAK_POINTS from '../../../../styling/media-queries';
import Disclaimer from '../../../../components/Disclaimer';

const Subheading = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 22px;
  color: #1b1b1b;
  padding-top: 1%;
  text-align: center;
  @media ${BREAK_POINTS.desktop} {
    text-align: left;
    margin-bottom: 10%;
    font-size: 22px;
    line-height: 26px;
  }
`;

const CalculatorSelectionContentText = styled.div`
  text-transform: uppercase;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  color: ${(props) => props.theme.colors.calculatorInvestmentHighlightFontColor};
  text-align: center;

  @media ${BREAK_POINTS.mobileBig} {
    font-size: 16px;
    line-height: 22px;
  }
`;

const CalculatorSelectionTotalLabelValue = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 40px;
  text-align: center;
  color: ${(props) => props.theme.colors.calculatorInvestmentHighlightFontColor};
`;

const CalculatorSelectionTotalLabelContainer = styled.div`
  background: ${(props) => props.theme.colors.calculatorInvestmentHighlight};
  line-height: 5em;
  border-radius: 6px;
  padding: 12px 20px;
  text-align: center;
`;

const CalculatorSelectionTotalHeadingsContainer = styled.div``;

export const DisclaimerContainer = styled.div`
  line-height: 20px;
  color: #000000;
  margin-top: 10px;
`;

const valueCalculatorHeading1 = getPartnerAsset<ReactElement>(DynamicAssetsKeys.valueCalculatorHeading1);
const valueCalculatorHeading2 = getPartnerAsset<string>(DynamicAssetsKeys.valueCalculatorHeading2);
const valueCalculatorSubtitle = getPartnerAsset<string>(DynamicAssetsKeys.valueCalculatorSubtitle);
const CalculatorHeading = getPartnerAsset<ElementType>(DynamicAssetsKeys.valueCalculatorHeadingComponent);

export const CalculatorSelectionTotalHeadings: React.FunctionComponent = () => {
  return (
    <CalculatorSelectionTotalHeadingsContainer>
      <CalculatorHeading>{valueCalculatorHeading1}</CalculatorHeading>
      <br />
      <CalculatorHeading>{valueCalculatorHeading2}</CalculatorHeading>
      <Subheading>{valueCalculatorSubtitle}</Subheading>
    </CalculatorSelectionTotalHeadingsContainer>
  );
};

export const CalculatorSelectionTotalLabel: React.FunctionComponent<CalculatorSelectionTotalPageProps> = (props) => {
  const { devices, deviceQuantities } = props;
  const [total, setTotal] = useState(0);

  useEffect((): void => {
    setTotal(devicesTotalValue(deviceQuantities, devices));
  }, [deviceQuantities]);

  return (
    <div>
      <CalculatorSelectionTotalLabelContainer {...props}>
        <CalculatorSelectionContentText>Your estimated tech investment</CalculatorSelectionContentText>
        <CalculatorSelectionTotalLabelValue>{formatDollars(total, 0)}</CalculatorSelectionTotalLabelValue>
      </CalculatorSelectionTotalLabelContainer>
      <DisclaimerContainer>
        <Disclaimer footnoteNumber={1}>
          Total device value based on 2018 Consumer Technology Ownership Report, published by CTA. Device price
          estimates based on category medians from nationwide retailer.
        </Disclaimer>
      </DisclaimerContainer>
    </div>
  );
};



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/calculator/selection/components/CalculatorSelectionTotal.tsx